import { useState, useEffect, useRef } from "react";
import Footer from "../components/Footer/Footer";
import {
  FaShieldHalved,
  FaStar,
  FaHeart,
  FaTrophy,
  FaGoogle,
  FaArrowUpRightFromSquare,
  FaWhatsapp,
  FaPhone,
} from "react-icons/fa6";

// Profile images
import avatar1 from "../images/testimonials/test1.jpg";
import avatar2 from "../images/testimonials/test2.jpg";
import avatar3 from "../images/testimonials/test3.jpg";
import avatar4 from "../images/testimonials/test4.jpg";
import heroImg from "../images/who-we-are/nandhu.png";
import quotesImg from "../images/testimonials/quotes.png";

function AnimatedCounter({ target, suffix, countersVisible }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!countersVisible) return;
    let start = 0;
    const duration = 2000;
    const stepTime = Math.max(Math.floor(duration / target), 20);
    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start >= target) {
        clearInterval(timer);
        setCount(target);
      }
    }, stepTime);
    return () => clearInterval(timer);
  }, [countersVisible, target]);

  return (
    <span>
      {count}
      {suffix}
    </span>
  );
}

function TestimonialsPage() {
  const [activeCard, setActiveCard] = useState(null);
  const [countersVisible, setCountersVisible] = useState(false);
  const statsRef = useRef(null);

  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "FAT2FIT Member, Coimbatore",
      rating: 5,
      text: "FAT2FIT completely transformed my lifestyle. Under coach Nandha Kumar's guidance, I lost 12kg of fat and built lean muscle in just 3 months. The atmosphere is fantastic!",
      avatar: avatar1,
      highlight: "Lost 8kg in 3 months",
      program: "Weight Loss + Strength",
    },
    {
      name: "Sneha Harish",
      role: "FAT2FIT Member, Echanari",
      rating: 5,
      text: "As a woman, finding a comfortable unisex gym was crucial. FAT2FIT is safe, clean, and the equipment is top-notch. Highly recommend their personal training program!",
      avatar: avatar2,
      highlight: "Top-notch experience",
      program: "Personal Training",
    },
    {
      name: "Manoj Prasanna",
      role: "FAT2FIT Member, Coimbatore",
      rating: 5,
      text: "The best fitness centre in Echanari. Coach G. Nandha Kumar's achievements like Mr. India Junior and Mr. Tamil Nadu speak for themselves, but his coaching is even better!",
      avatar: avatar3,
      highlight: "Expert-level coaching",
      program: "Bodybuilding",
    },
    {
      name: "Priya Dev",
      role: "FAT2FIT Member, Echanari",
      rating: 5,
      text: "I joined for weight loss, and the custom nutrition plan combined with strength training gave me amazing results. The team keeps you motivated daily.",
      avatar: avatar4,
      highlight: "Amazing transformation",
      program: "Nutrition + Training",
    },
  ];

  const stats = [
    { value: 500, suffix: "+", label: "Happy Members" },
    { value: 5, suffix: "★", label: "Average Rating" },
    { value: 98, suffix: "%", label: "Retention Rate" },
    { value: 3, suffix: "+", label: "Years of Trust" },
  ];

  // Animated counter hook
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setCountersVisible(true);
        }
      },
      { threshold: 0.3 }
    );
    if (statsRef.current) {
      observer.observe(statsRef.current);
    }
    return () => observer.disconnect();
  }, []);



  return (
    <>
      <section className="bg-black text-white min-h-screen">
        {/* Hero Banner */}
        <div className="login-banner relative justify-center flex bg-brand-gradient">
          <h1 className="text-white absolute bottom-[20px] sm:bottom-[25px] text-[26px] sm:text-[34px] md:text-[40px] font-extrabold uppercase text-center px-4">
            Member Testimonials
          </h1>
        </div>

        {/* Intro Section with Hero Image */}
        <div className="container page-padding py-12 sm:py-16 md:py-20">
          <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-10 lg:gap-16">
            {/* Text Side */}
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block text-[#ff0336] text-[11px] sm:text-[12px] font-bold uppercase tracking-[3px] mb-3 sm:mb-4">
                ★ Trusted by 500+ members
              </span>
              <h2 className="text-[26px] sm:text-[32px] md:text-[40px] font-extrabold mb-4 sm:mb-6 leading-tight">
                Real Stories From
                <br />
                <span className="text-brand-gradient">Our Champions</span>
              </h2>
              <p className="text-neutral-400 text-[14px] sm:text-[16px] leading-relaxed max-w-xl mx-auto lg:mx-0">
                Read how our members achieved their goals, built strength, and
                transformed their lives at{" "}
                <span className="text-[#ffd600] font-semibold">
                  FAT2FIT Unisex Fitness Centre
                </span>{" "}
                under expert coaching by{" "}
                <span className="text-white font-semibold">
                  Coach G. Nandha Kumar
                </span>
                .
              </p>

              {/* Mini trust badges */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-3 sm:gap-4 mt-6 sm:mt-8">
                <div className="flex items-center gap-2 bg-[#111] border border-neutral-800 rounded-full px-3 sm:px-4 py-2">
                  <FaShieldHalved className="text-[#ffd600] text-[12px] sm:text-[13px]" />
                  <span className="text-[11px] sm:text-[12px] text-neutral-300 font-medium">
                    Verified Reviews
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-[#111] border border-neutral-800 rounded-full px-3 sm:px-4 py-2">
                  <FaStar className="text-[#ffd600] text-[12px] sm:text-[13px]" />
                  <span className="text-[11px] sm:text-[12px] text-neutral-300 font-medium">
                    5.0 Rated
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-[#111] border border-neutral-800 rounded-full px-3 sm:px-4 py-2">
                  <FaHeart className="text-[#ff0336] text-[12px] sm:text-[13px]" />
                  <span className="text-[11px] sm:text-[12px] text-neutral-300 font-medium">
                    98% Retention
                  </span>
                </div>
              </div>
            </div>

            {/* Image Side */}
            <div className="flex-1 w-full max-w-md lg:max-w-lg relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#ff033620]">
                <img
                  src={heroImg}
                  alt="FAT2FIT Members Training"
                  className="w-full h-[280px] sm:h-[340px] md:h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

                {/* Floating rating card */}
                <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 bg-black/80 backdrop-blur-md border border-neutral-700 rounded-xl px-4 py-3 sm:px-5 sm:py-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <FaStar
                        key={i}
                        className="text-[#ffd600] text-[11px] sm:text-[13px]"
                      />
                    ))}
                  </div>
                  <p className="text-white text-[11px] sm:text-[13px] font-bold">
                    5.0 from 500+ members
                  </p>
                </div>
              </div>

              {/* Decorative accent */}
              <div className="absolute -top-3 -right-3 w-16 h-16 sm:w-20 sm:h-20 border-2 border-[#ffd600] rounded-2xl opacity-30 hidden sm:block"></div>
              <div className="absolute -bottom-3 -left-3 w-12 h-12 sm:w-16 sm:h-16 bg-[#ff0336] rounded-xl opacity-10 hidden sm:block"></div>
            </div>
          </div>
        </div>

        {/* Animated Stats Bar */}
        <div
          ref={statsRef}
          className="bg-[#111] border-y border-neutral-800 py-8 sm:py-10 md:py-12"
        >
          <div className="container page-padding">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
              {stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-[28px] sm:text-[36px] md:text-[42px] font-extrabold text-brand-gradient leading-none mb-1 sm:mb-2">
                    <AnimatedCounter
                      target={stat.value}
                      suffix={stat.suffix}
                      countersVisible={countersVisible}
                    />
                  </div>
                  <p className="text-neutral-400 text-[12px] sm:text-[13px] md:text-[14px] font-medium uppercase tracking-wider">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="py-12 sm:py-16 md:py-20">
          <div className="container page-padding">
            <div className="text-center mb-10 sm:mb-14">
              <h2 className="text-[24px] sm:text-[28px] md:text-[32px] font-bold relative inline-block">
                What Our Members Say
                <span className="w-[80px] h-[4px] bg-[#ff0336] absolute -bottom-3 left-1/2 -translate-x-1/2"></span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
              {testimonials.map((t, idx) => (
                <div
                  key={idx}
                  className={`relative bg-[#111] border rounded-2xl overflow-hidden transition-all duration-500 shadow-xl hover:shadow-2xl hover:shadow-[#ff033615] group ${
                    activeCard === idx
                      ? "border-[#ffd600] scale-[1.02]"
                      : "border-neutral-800 hover:border-[#ff0336]"
                  }`}
                  onMouseEnter={() => setActiveCard(idx)}
                  onMouseLeave={() => setActiveCard(null)}
                >
                  {/* Top section: avatar + program badge */}
                  <div className="flex items-center gap-4 sm:gap-5 p-5 sm:p-7 pb-0">
                    {/* Avatar */}
                    <div className="relative flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-2 border-neutral-700 group-hover:border-[#ffd600] transition-colors duration-300"
                      />
                      {/* Online indicator */}
                      <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 sm:w-5 sm:h-5 bg-green-500 rounded-full border-2 border-[#111]"></div>
                    </div>

                    {/* Name + Role */}
                    <div className="flex-1 min-w-0">
                      <h4 className="text-[16px] sm:text-[18px] font-bold text-white truncate">
                        {t.name}
                      </h4>
                      <p className="text-[11px] sm:text-[12px] text-neutral-400 mb-1.5">
                        {t.role}
                      </p>
                      {/* Program tag */}
                      <span className="inline-block bg-[#ff033618] text-[#ff0336] text-[10px] sm:text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md">
                        {t.program}
                      </span>
                    </div>

                    {/* Rating */}
                    <div className="flex flex-col items-end gap-1 flex-shrink-0">
                      <div className="flex gap-0.5">
                        {[...Array(t.rating)].map((_, i) => (
                          <FaStar
                            key={i}
                            className="text-[#ffd600] text-[11px] sm:text-[13px]"
                          />
                        ))}
                      </div>
                      <span className="text-neutral-500 text-[10px] sm:text-[11px] font-medium">
                        {t.rating}.0
                      </span>
                    </div>
                  </div>

                  {/* Testimonial body */}
                  <div className="p-5 sm:p-7 pt-4 sm:pt-5 relative">
                    {/* Quotes icon */}
                    <img
                      src={quotesImg}
                      alt=""
                      className="w-6 h-6 sm:w-8 sm:h-8 opacity-20 mb-2 sm:mb-3"
                    />

                    <p className="text-[13.5px] sm:text-[15px] text-neutral-300 leading-relaxed italic">
                      "{t.text}"
                    </p>

                    {/* Highlight result */}
                    <div className="mt-4 sm:mt-5 flex items-center gap-2 sm:gap-3 bg-black/40 rounded-lg px-3 sm:px-4 py-2.5 sm:py-3 border border-neutral-800">
                      <FaTrophy className="text-[#ffd600] text-[13px] sm:text-[14px]" />
                      <span className="text-[12px] sm:text-[13px] font-semibold text-[#ffd600]">
                        {t.highlight}
                      </span>
                    </div>
                  </div>

                  {/* Decorative gradient line at bottom */}
                  <div className="h-[3px] bg-brand-gradient opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Google Review CTA Strip */}
        <div className="bg-[#111] border-y border-neutral-800 py-8 sm:py-10">
          <div className="container page-padding flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-center sm:text-left">
            <div className="flex items-center gap-2 sm:gap-3">
              <FaGoogle className="text-[24px] sm:text-[28px] text-white" />
              <div>
                <div className="flex gap-0.5 mb-0.5">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className="text-[#ffd600] text-[12px] sm:text-[14px]"
                    />
                  ))}
                </div>
                <p className="text-neutral-400 text-[11px] sm:text-[12px]">
                  Rated 5.0 on Google Reviews
                </p>
              </div>
            </div>
            <a
              href="https://www.google.com/maps"
              target="_blank"
              rel="noreferrer"
              className="bg-white text-black font-bold text-[12px] sm:text-[13px] uppercase tracking-wider px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg hover:bg-[#ffd600] transition duration-300 flex items-center gap-2"
            >
              <FaArrowUpRightFromSquare className="text-[11px] sm:text-[12px]" />
              Read on Google
            </a>
          </div>
        </div>

        {/* Call to Action */}
        <div className="py-12 sm:py-16 md:py-20">
          <div className="container page-padding">
            <div className="relative bg-[#111] rounded-2xl sm:rounded-3xl overflow-hidden border border-neutral-800 shadow-2xl max-w-4xl mx-auto">
              {/* Decorative blobs */}
              <div className="absolute top-0 right-0 w-48 h-48 sm:w-64 sm:h-64 bg-[#ff033620] rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute bottom-0 left-0 w-36 h-36 sm:w-48 sm:h-48 bg-[#ffd60015] rounded-full blur-[60px] translate-y-1/2 -translate-x-1/2"></div>

              <div className="relative z-10 p-6 sm:p-10 md:p-14 text-center">
                <span className="inline-block text-[#ff0336] text-[11px] sm:text-[12px] font-bold uppercase tracking-[3px] mb-3 sm:mb-4">
                  Your Journey Starts Here
                </span>
                <h3 className="text-[22px] sm:text-[28px] md:text-[34px] font-extrabold mb-3 sm:mb-4 leading-tight">
                  Start Your Own
                  <br />
                  <span className="text-brand-gradient">Success Story</span>
                </h3>
                <p className="text-neutral-400 text-[13px] sm:text-[15px] mb-6 sm:mb-8 max-w-xl mx-auto leading-relaxed">
                  Book your free trial session today and take the first step
                  towards a legend's lifestyle. Train under Coach G. Nandha Kumar —
                  Mr. India Junior & Mr. Tamil Nadu champion.
                </p>

                {/* Avatars stack */}
                <div className="flex items-center justify-center mb-6 sm:mb-8">
                  <div className="flex -space-x-3 sm:-space-x-4">
                    {testimonials.map((t, i) => (
                      <img
                        key={i}
                        src={t.avatar}
                        alt={t.name}
                        className="w-9 h-9 sm:w-11 sm:h-11 rounded-full border-2 border-black object-cover"
                      />
                    ))}
                  </div>
                  <span className="ml-3 sm:ml-4 text-neutral-400 text-[12px] sm:text-[13px]">
                    Join{" "}
                    <span className="text-[#ffd600] font-bold">500+</span>{" "}
                    members
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
                  <a
                    href="https://wa.me/918637488702?text=Hi%20Nandha%2C%20I%20read%20the%20member%20reviews%20and%20want%20to%20book%20a%20free%20trial!"
                    target="_blank"
                    rel="noreferrer"
                    className="bg-brand-gradient text-white font-bold uppercase text-[13px] sm:text-[14px] px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl hover-brand-gradient transition duration-300 shadow-lg shadow-[#ff033630] flex items-center justify-center gap-2"
                  >
                    <FaWhatsapp className="text-[18px] sm:text-lg" />{" "}
                    Book Free Trial
                  </a>
                  <a
                    href="tel:8637488702"
                    className="border-2 border-neutral-700 text-white hover:border-[#ff0336] hover:bg-[#ff033615] font-bold uppercase text-[13px] sm:text-[14px] px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl transition duration-300 flex items-center justify-center gap-2"
                  >
                    <FaPhone className="text-[14px] sm:text-base" />{" "}
                    Call Coach Nandha
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </section>
    </>
  );
}

export default TestimonialsPage;
